import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { wysiwyg } from '../../../styleguide/exampledata/example-content';

@Component({
  selector: 'app-content-panel',
  imports: [NgClass],
  templateUrl: './content-panel.component.html',
  styleUrl: './content-panel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentPanelComponent {
  readonly datacolor = input<string>();

  color = computed(() => {
    const datacolor = this.datacolor();
    if (datacolor === 'null' || !datacolor) {
      return 'light';
    }
    return datacolor;
  });

  wysiwyg = wysiwyg;
}
